import { ReferrerDomainSchema, UtmValueSchema } from "@pushback-and-chaos/contracts";
/**
 * THE VISIT BEACON's transport (ADR 0022), here because this package owns
 * every URL the web client touches: the beacon's path, and reading the
 * landing URL and the referrer. The web decides whether to count at all
 * (GPC, DNT, the opt-out) and calls these only when it may.
 */
/**
 * What a landing view adds: the referrer's host if it is another site, and
 * each campaign tag from the URL's query that meets the contract (one that
 * does not is left out rather than refusing the whole view). Nothing else
 * from the URL is read.
 */
export function landingFields(href, referrer) {
    const fields = {};
    const here = parse(href);
    if (referrer.length > 0) {
        const from = parse(referrer);
        const host = from?.hostname.toLowerCase();
        if (host !== undefined && host !== here?.hostname.toLowerCase() && ReferrerDomainSchema.safeParse(host).success)
            fields.referrer = host;
    }
    if (here !== null) {
        const tag = (name) => {
            const parsed = UtmValueSchema.safeParse(here.searchParams.get(name) ?? "");
            return parsed.success ? parsed.data : undefined;
        };
        const source = tag("utm_source");
        const medium = tag("utm_medium");
        const campaign = tag("utm_campaign");
        if (source !== undefined)
            fields.utmSource = source;
        if (medium !== undefined)
            fields.utmMedium = medium;
        if (campaign !== undefined)
            fields.utmCampaign = campaign;
    }
    return fields;
}
function parse(url) {
    try {
        return new URL(url);
    }
    catch {
        return null;
    }
}
/**
 * `POST {baseUrl}/a/v`, fire and forget: `sendBeacon` first, so a view
 * counted as the page closes still goes; a keepalive request where the
 * browser has none or refuses. The answer is always an empty 204 and is never
 * read.
 */
export function sendVisitBeacon(baseUrl, beacon, transport) {
    const url = `${baseUrl}/a/v`;
    const body = JSON.stringify(beacon);
    try {
        if (transport.sendBeacon?.(url, new Blob([body], { type: "application/json" })) === true)
            return;
    }
    catch {
        // Fall through to fetch.
    }
    void transport.fetch(url, { method: "POST", body, headers: { "content-type": "application/json" }, keepalive: true, credentials: "same-origin" }).catch(() => undefined);
}
//# sourceMappingURL=visit-beacon.js.map